<template>
    <v-container container--fluid>
        <v-layout align-center justify-center>
            <v-flex xs12 sm12 md10>
                <v-card class="elevation-12">
                    <v-toolbar flat dark color="primary">
                        <v-toolbar-title>Login</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="px-3">
                        <v-layout row class="pa-0 mx-2">
                            <v-flex xs12 sm12 md12>
                                <v-alert class="my-4" :value="true" color="primary lighten-2" icon="info" outlined
                                    >Enter your username and password to access your account.</v-alert
                                >
                            </v-flex>
                        </v-layout>
                        <v-form class="overwrite-inputs" ref="loginform" v-model.trim="valid" lazy-validation>
                            <v-flex xs12 sm12 md12>
                                <v-text-field
                                    placeholder="Username*"
                                    prepend-icon="person"
                                    v-model.trim="username"
                                    :rules="usernameRules"
                                    :error="authErrors.has('username')"
                                    :error-messages="authErrors.get('username')"
                                    required
                                >
                                    <v-tooltip slot="append-outer" bottom
                                        ><v-icon v-slot:activator="{ on }">help</v-icon>
                                        Enter your username.
                                    </v-tooltip>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-text-field
                                    prepend-icon="lock"
                                    v-model.trim="password"
                                    :append-icon="showpwd ? 'visibility_off' : 'visibility'"
                                    :type="showpwd ? 'text' : 'password'"
                                    name="password"
                                    :rules="passwordRules"
                                    :error="authErrors.has('password')"
                                    :error-messages="authErrors.get('password')"
                                    placeholder="Password*"
                                    @click:append="showpwd = !showpwd"
                                    required
                                    @keyup.enter="login"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-checkbox v-model.trim="remember" label="Remember Me"></v-checkbox>
                            </v-flex>
                        </v-form>
                        <v-alert v-model.trim="alert" outlined transition="scale-transition" dismissible type="error">{{ authErrors.get("invalid_credentials") }}</v-alert>
                    </v-card-text>
                    <v-card-actions class="pb-4 px-3">
                        <v-btn @click="clear" color="warning" :disabled="loginLoading" class="text-left">clear<v-icon right>clear</v-icon></v-btn>
                        <v-btn :loading="loginLoading" :disabled="!valid" color="primary" @click="login" class="text-left">login<v-icon right>send</v-icon></v-btn>
                    </v-card-actions>
                    <v-divider light></v-divider>
                    <v-card-text>
                        <div class="text-center">
                            <router-link :to="{ name: 'username-email' }" class="mr-4"><v-btn small text color="primary">Forgot Username</v-btn></router-link
                            ><router-link :to="{ name: 'password-email' }"><v-btn small text color="primary">Forgot / Reset your password</v-btn></router-link>
                        </div>
                        <div class="text-center pt-2"><span color="gray--text">No Account?</span> <router-link :to="{ name: 'register' }">Register</router-link></div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            username: "",
            usernameRules: [v => !!v || "Username is required"],
            password: "",
            passwordRules: [v => !!v || "Password is required"],
            remember: false,
            valid: true,
            showpwd: false,
            alert: false,
        };
    },
    computed: {
        authErrors() {
            return this.$store.getters["auth/authErrors"];
        },
        loginLoading() {
            return this.$store.getters["auth/authStatus"] == "loading";
        },
    },
    methods: {
        clear() {
            this.alert = false;
            this.$refs.loginform.reset();
            this.$store.dispatch("auth/clearErrors");
        },
        login: function() {
            if (this.$refs.loginform.validate()) {
                // this.loginLoading = true;
                this.valid = false;
                const { username, password, remember } = this;
                const xyz = this.$route.params.xyz;
                const zyx = this.$route.params.zyx;

                this.$store
                    .dispatch("auth/authRequest", { username, password, remember, xyz, zyx })
                    .then(() => {
                        // this.loginLoading = false
                        // this.$router.push({ name: 'dashboard'});
                        this.$router.push(this.$route.query.redirect || "/member/account");
                    })
                    .catch(err => {
                        // this.loginLoading = false
                        this.valid = true;

                        if (this.authErrors.has("invalid_credentials")) {
                            this.alert = true;
                            // var _self = this;
                            // setTimeout(function(){
                            //     _self.alert = false;
                            // }, 3000);
                        }
                    });
            }
        },
    },
};
</script>
